import Swiper from 'swiper/bundle'
import {gsap} from 'gsap'
import 'swiper/css/bundle'
import mobShare from '../../resources/js/module/mobShare'
import businessExampleHover from "../../resources/js/module/business-example";

const swiperBlock = $('.single-addition-related__list')

if (swiperBlock) {
  new Swiper('.single-addition-related__list', {
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    navigation: {
      nextEl: '.custom-slide-btn-next',
      prevEl: '.custom-slide-btn-prev',
    },
    pagination: {
      el: '.custom-swiper-pagination',
      bulletClass: 'custom-swiper-pagination__bullet',
      clickable: true,
    },
    breakpoints: {
      // when window width is >= 320px
      460: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      800: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  })
}

swiperBlock.find('.topics-related-post').hover(function () {
  gsap.to($(this), {y: '-20'})
  $(this).removeClass('blur')
}, function () {
  gsap.to($(this), {y: '0'})
})

businessExampleHover();

mobShare()
